/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FunctionComponent } from 'react'
import styled from 'styled-components/native'

import { RemoteIllustration } from 'ui/components/RemoteIllustration'
import { ViewGap } from 'ui/components/ViewGap/ViewGap'
import { BaseModalSimpleProps } from 'ui/designSystem/ModalSimple/types'
import { Typo } from 'ui/theme'
import { setTextSemantic } from 'ui/theme/typographyAttrs/setTextSemantic'

export const ModalSimpleContent: FunctionComponent<BaseModalSimpleProps> = ({
  title,
  illustration,
  description,
}) => {
  return (
    <ModalContainer gap={6}>
      <ContentContainer gap={6}>
        {illustration ? <RemoteIllustration {...illustration} size="s" /> : null}

        <TextsContainer gap={4}>
          <Title {...setTextSemantic('h1')}>{title}</Title>
          {description ? <Description>{description}</Description> : null}
        </TextsContainer>
      </ContentContainer>
    </ModalContainer>
  )
}

const ModalContainer = styled(ViewGap)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.designSystem.color.background.default,
  paddingHorizontal: theme.designSystem.size.spacing.xxl,
}))

const ContentContainer = styled(ViewGap)({
  alignItems: 'center',
})

const TextsContainer = styled(ViewGap)({
  alignItems: 'center',
})

const Title = styled(Typo.Title4)(({ theme }) => ({
  color: theme.designSystem.color.text.default,
  textAlign: 'center',
}))

const Description = styled(Typo.Body)(({ theme }) => ({
  color: theme.designSystem.color.text.default,
  textAlign: 'center',
}))
